// Global styles for CssBaseline
export const globalStyles = {
    '*': {
        boxSizing: 'border-box',
    },
    '*::before': {
        boxSizing: 'border-box',
    },
    '*::after': {
        boxSizing: 'border-box',
    },
    'body': {
        lineHeight: 1.5,
        WebkitFontSmoothing: 'antialiased',
        MozOsxFontSmoothing: 'grayscale',
        textRendering: 'optimizeLegibility',
        overflowX: 'hidden',
        msOverflowStyle: 'none',
        scrollbarWidth: 'none',
    },
    'html': {
        overflowX: 'hidden',
    },
    'img, picture, video, canvas, svg': {
        display: 'block',
        maxWidth: '100%',
        height: 'auto',
    },
    'input, button, textarea, select': {
        font: 'inherit',
    },
    'p, h1, h2, h3, h4, h5, h6': {
        overflowWrap: 'break-word',
    },
    'table': {
        borderCollapse: 'collapse',
        borderSpacing: 0,
    },
    'ul, ol': {
        listStyle: 'none',
        margin: 0,
        padding: 0,
    },
    'button': {
        cursor: 'pointer',
    },
    'a': {
        color: 'inherit',
        textDecoration: 'none',
    },
    // Custom scrollbar for webkit browsers
    '::-webkit-scrollbar': {
        display: 'none',
    },
    '::-webkit-scrollbar-track': {
        background: '#f1f1f1',
    },
    '::-webkit-scrollbar-thumb': {
        background: '#c1c1c1',
        borderRadius: '4px',
    },
    '::-webkit-scrollbar-thumb:hover': {
        background: '#a8a8a8',
    },
    // Focus styles
    ':focus-visible': {
        outline: '2px solid #005fcc',
        outlineOffset: '2px',
    },
    // Reduced motion support
    '@media (prefers-reduced-motion: reduce)': {
        '*': {
            animationDuration: '0.01ms !important',
            animationIterationCount: '1 !important',
            transitionDuration: '0.01ms !important',
            scrollBehavior: 'auto !important',
        },
        '*::before': {
            animationDuration: '0.01ms !important',
            animationIterationCount: '1 !important',
            transitionDuration: '0.01ms !important',
        },
        '*::after': {
            animationDuration: '0.01ms !important',
            animationIterationCount: '1 !important',
            transitionDuration: '0.01ms !important',
        },
    },
};
